import React, { useState, useEffect } from "react";
import { td } from "../../Shared/Styles";

export default function ConditionList(conditionDetails) {
  const [conditionList] = useState(conditionDetails.cl);

  if (conditionList !== undefined) {
    return conditionList.map((data) => {
      return (
        <>
          <React.Fragment>
            <tbody>
              <tr>
                <td style={{border: '1px solid black', textAlign: 'left', fontSize: '15px', width: '12%', marginBottom: '13px', color: 'black', borderTop: '0px', paddingLeft: '20px' }}>{data.benefitType}</td>
                <td style={td}>{data.riskLoading}</td>
                {data.perMilleLoading === "" ? (
                  <td style={td}>$0</td>
                ) : (
                  <td style={td}>${data.perMilleLoading}</td>
                )}

                {data.hasExclusion === false ? (
                  <td style={td}>No</td>
                ) : (
                  <td style={td}>Yes</td>
                )}
              </tr>
            </tbody>
          </React.Fragment>
        </>
      );
    });
  }
}
